import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import { getCurrentUser } from "vuefire";
import PaymentsSummaryVue from "../pages/PaymentsSummary.vue";
import StorePaymentsSummaryVue from "../pages/StorePaymentsSummary.vue";
import StorePayoutsSummaryVue from "../pages/StorePayoutsSummary.vue";
import StorePaymentsPageVue from "../pages/StorePaymentsPage.vue";
import ProfitReportPageVue from "../pages/ProfitReportPage.vue";

function lazyView(view: string) {
  return () => import(`../pages/${view}.vue`);
}
const StorePage = () => import("../pages/StorePage.vue");
const StoreDetailPage = () => import("../pages/StoreDetailPage.vue");
const StorePayoutsPage = () => import("../pages/StorePayouts.vue");
const StoreSettingsPage = () => import("../pages/StoreSettingsPage.vue");
const StoreSettingsCommissionPage = () =>
  import("../pages/StoreSettingsCommissionPage.vue");
const StoreSettingsSweepPage = () =>
  import("../pages/StoreSettingsSweepPage.vue");
const DashboardPage = () => import("../pages/DashboardPage.vue");
const StoreSettingsSplitConfigurationPage = () =>
  import("../pages/StoreSettingsSplitConfigurationPage.vue");

const StoreSettingsTerminalPage = () =>
  import("../pages/StoreSettingsTerminalPage.vue");
const StoreSettingsLogo = () => import("../pages/StoreSettingLogo.vue");
const StoreSettingsPasscodes = () =>
  import("../pages/StoreSettingsPasscodesPage.vue");
const StoreSettingsEnableStandalone = () =>
  import("../pages/StoreSettingsEnableStandalone.vue");
const StoreSettingsEnableWechatpayPos = () =>
  import("../pages/StoreSettingsEnableWechatpayPos.vue");
const StoreSettingsEnableAlipayPos = () =>
  import("../pages/StoreSettingsEnableAlipayPos.vue");
const StoreSettingsEnableSamedaySettlement = () =>
  import("../pages/StoreSettingsEnableSamedaySettlement.vue");
const StoreSettingsSurchargePage = () =>
  import("../pages/StoreSettingsSurchargePage.vue");
const StoreSettingsTips = () => import("../pages/StoreSettingsTips.vue");
const StoreSettingsBonusPage = () =>
  import("../pages/StoreSettingsBonusPage.vue");
const StoreSettingsABNPage = () => import("../pages/StoreSettingsABNPage.vue");
const ReceiptPage = () => import("../pages/ReceiptPage.vue");
const routes: Array<RouteRecordRaw> = [
  {
    path: "/receipts/:id",
    name: "ReceiptPage",
    component: ReceiptPage,
  },
  {
    path: "/",
    name: "Intro",
    component: DashboardPage,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "home-redirect",
        redirect: (_to) => ({ name: "payments-summary" }),
      },
      {
        path: "dashboard",
        name: "HomePage",
        component: lazyView("HomePage"),
      },
      {
        path: "home",
        name: "payments-summary",
        component: StorePaymentsSummaryVue,
      },
      {
        path: "report",
        name: "report",
        component: ProfitReportPageVue,
      },
      {
        path: "payments/:user/:merchant/:store/:date",
        name: "store-payments",
        component: StorePaymentsPageVue,
      },
      {
        path: "help",
        name: "HelPage",
        component: lazyView("HelpPage"),
      },
      {
        path: "get-connected",
        name: "OnboardingPage",
        component: lazyView("OnboardingPage"),
      },
      {
        path: "/paymentssfs",
        name: "PaymentsPage",
        component: lazyView("PaymentsPage"),
      },
      {
        path: "/stores",
        name: "StoresPage",
        component: lazyView("StoresPage"),
      },
      {
        path: "/stores/:store/settings",
        name: "UserStoreSettingsPage",
        component: lazyView("SettingsPage"),
      },
      {
        path: "/merchants/:merchant/payouts",
        name: "PayoutsPage",
        component: lazyView("MerchantPayoutPage"),
      },

      {
        path: "/merchants/:merchant/new-order",
        name: "NewOrder",
        component: lazyView("NewOrderPage"),
      },
      {
        path: "/merchants/:merchant/orders",
        name: "OrderPage",
        component: lazyView("OrderPage"),
      },
      {
        path: "/merchants/:merchant/stores/:store",
        name: "StorePage",
        component: StorePage,
        children: [
          {
            path: "",
            name: "store-redirect",
            redirect: (_to) => ({ name: "StoreDetailPage" }),
          },
          {
            path: "admin-payments",
            name: "admin-payments-summary",
            component: PaymentsSummaryVue,
          },

          {
            path: "payouts",
            name: "payouts-summary",
            component: StorePayoutsSummaryVue,
          },

          {
            path: "admin-payments/:date",
            name: "StoreDetailPage",
            component: StoreDetailPage,
          },
          {
            path: "dashboard",
            name: "StorePayoutsPage",
            component: StorePayoutsPage,
          },
          {
            path: "settings",
            name: "StoreSettingsPage",
            component: StoreSettingsPage,
            children: [
              {
                path: "",
                name: "settings-redirect",
                redirect: (_to) => ({ name: "StoreSettingsTerminalPage" }),
              },
              {
                path: "commission",
                name: "StoreSettingsCommissionPage",
                component: StoreSettingsCommissionPage,
              },
              {
                path: "bonus",
                name: "StoreSettingsBonusPage",
                component: StoreSettingsBonusPage,
              },
              {
                path: "abn",
                name: "StoreSettingsABNPage",
                component: StoreSettingsABNPage,
              },
              {
                path: "sweep",
                name: "StoreSettingsSweepPage",
                component: StoreSettingsSweepPage,
              },
              {
                path: "terminal",
                name: "StoreSettingsTerminalPage",
                component: StoreSettingsTerminalPage,
                props: true,
              },
              {
                path: "surcharge",
                name: "StoreSettingsSurchargePage",
                component: StoreSettingsSurchargePage,
                props: true,
              },
              {
                path: "tips",
                name: "StoreSettingsTips",
                component: StoreSettingsTips,
                props: true,
              },
              {
                path: "split-configuration",
                name: "StoreSettingsSplitConfigurationPage",
                component: StoreSettingsSplitConfigurationPage,
              },
              {
                path: "logo",
                name: "StoreSettingsLogo",
                component: StoreSettingsLogo,
              },
              {
                path: "passcodes",
                name: "StoreSettingsPasscodes",
                component: StoreSettingsPasscodes,
              },
              {
                path: "standalone",
                name: "StoreSettingsEnableStandalone",
                component: StoreSettingsEnableStandalone,
              },
              {
                path: "wechatpaypos",
                name: "StoreSettingsEnableWechatpayPos",
                component: StoreSettingsEnableWechatpayPos,
              },
              {
                path: "alipaypaypos",
                name: "StoreSettingsEnableAlipayPos",
                component: StoreSettingsEnableAlipayPos,
              },
              {
                path: "sameday-settlement",
                name: "StoreSettingsEnableSamedaySettlement",
                component: StoreSettingsEnableSamedaySettlement,
              },
            ],
          },
        ],
      },

      {
        path: "/new-store",
        name: "NewVenuePage",
        component: lazyView("NewVenuePage"),
      },
      {
        path: "/onboarding",
        name: "Onboarding",
        component: lazyView("Onboarding"),
      },
      {
        path: "/add-store",
        name: "NewStorePage",
        component: lazyView("NewStorePage"),
      },
      {
        path: "/manual-transfer",
        name: "ManualTransferPage",
        component: lazyView("ManualTransferPage"),
      },
    ],
  },
  {
    path: "/login",
    name: "LoginPage",
    component: lazyView("LoginWithEmailPage"),
  },
  {
    path: "/checkout",
    name: "CheckoutPage",
    component: lazyView("CheckoutPage"),
  },
  {
    path: "/login-with-email",
    name: "LoginWithEmailPage",
    component: lazyView("LoginWithEmailPage"),
  },
  {
    path: "/email-signin",
    name: "EmailSignPage",
    component: lazyView("EmailSigninPage"),
  },
  {
    path: "/7499",
    name: "BalancesPage",
    component: lazyView("BalancesPage"),
  },
  {
    path: "/cass",
    name: "CassPage",
    component: lazyView("CassPage"),
  },
  {
    path: "/rex",
    name: "RexPage",
    component: lazyView("RexPage"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  // routes with `meta: { requiresAuth: true }` will check for
  // the users, others won't
  if (to.meta.requiresAuth) {
    const currentUser = await getCurrentUser();
    // if the user is not logged in, redirect to the login page
    if (!currentUser) {
      return {
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      };
    }
  }
});

export default router;
